import { eventBus } from './src-utils-event-bus.js';
import { isStudioPage } from './src-utils-chat-page-utils.js';

const isHelpPanelAnywherePage = () => {
  return isStudioPage();
};
const sendEventToHelpAnywherePanel = (type, additionalInfo = {}) => {
  const data = { origin: "CA", type, additionalInfo };
  eventBus.dispatch("eventToHelpAnywherePanel", data);
};

export { isHelpPanelAnywherePage, sendEventToHelpAnywherePanel };
//# sourceMappingURL=src-utils-chat-help-panel-utils.js.map
